module.exports = __webpack_public_path__ + "img/access_3.e10e1e73.jpg";